import {
  Component,
  Input,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  ContentChild,
  TemplateRef
} from '@angular/core'
import { fadeAnimation } from './animation'

export const ICON_CLASS_MAP: { [key: string]: string } = {
  success: 'icos-icon-success',
  warning: 'icos-icon-warning',
  error: 'icos-icon-error',
  info: 'icos-icon-info'
}

@Component({
  selector: 'icos-alert',
  animations: [fadeAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div [class]="'icos-alert icos-alert--' + type" [@fadeAnimation]="!visible" [class.is-center]="center" role="alert">
      <i [class]="'icos-alert__icon ' + makeIconClass()" *ngIf="showIcon"></i>
      <div class="icos-alert__content">
        <span [class]="'icos-alert__title ' + makeTitleClass()">
          <ng-content></ng-content>
        </span>
        <p class="icos-alert__description" *ngIf="description && !descriptionTmp">{{ description }}</p>
        <p class="icos-alert__description" *ngIf="descriptionTmp">
          <ng-template [ngTemplateOutlet]="descriptionTmp"></ng-template>
        </p>
        <i
          class="icos-alert__closebtn"
          *ngIf="closable"
          [class.is-customed]="closeText !== ''"
          [class.icos-icon-close]="closeText === ''"
          (click)="clickHandle($event)"
        >
          {{ closeText }}
        </i>
      </div>
    </div>
  `
})
export class IcosAlert {
  @ContentChild('description') descriptionTmp: TemplateRef<any>

  @Input() type: string = 'info'
  @Input() center: boolean = false
  @Input() description: string
  @Input() closable: boolean = true
  @Input('close-text') closeText: string = ''
  @Input('show-icon') showIcon: boolean = false
  @Output() close: EventEmitter<Event> = new EventEmitter<Event>()

  visible: boolean = true

  makeIconClass(): string {
    const base: string = ICON_CLASS_MAP[this.type] || 'icos-icon-info'
    const isBig: string = this.description || this.descriptionTmp ? ' is-big' : ''
    return base + isBig
  }

  makeTitleClass(): string {
    return this.description || this.descriptionTmp ? ' is-bold' : ''
  }

  clickHandle(event: Event): void {
    this.visible = false
    this.close.emit(event)
  }
}
